import { Component } from '@angular/core';

@Component({
    selector: 'app-system',
    templateUrl: './system.component.html',
    styleUrl: './system.component.scss',
    standalone: false
})
export class SystemComponent {

}
